import { TSelectOption } from '@treedis/tour-loader';
import { useCallback, useMemo } from 'react';
import TreedisPublicDAO from '@/api/TreedisPublicDAO';

type TDuplicate = {
  language: string;
  languageEn?: string;
  slug: string;
};

const useLanguage = ({ initialDuplicates, tourSlug }: { initialDuplicates?: TDuplicate[]; tourSlug: string }) => {
  const languageOptions = useMemo(
    () =>
      initialDuplicates
        ?.map((duplicate) => ({
          label: duplicate?.language || duplicate?.languageEn,
          value: duplicate.slug,
        }))
        .filter((o) => !!o.label),
    [initialDuplicates],
  );

  const defaultLanguage = useMemo(() => languageOptions?.find((o) => o.value === tourSlug), [languageOptions, tourSlug]);

  const handleChange = useCallback(
    async (lang: TSelectOption) => {
      const tourRes = await TreedisPublicDAO.getTourBySlug({ slug: lang.value });

      const gameId = tourRes?.tour?.gameId;
      const slug = tourRes?.tour?.slug;
      if (gameId && slug && slug !== defaultLanguage?.value) {
        window.location.replace(`${window.location.origin}/experience/${gameId}/${slug}`);
      }
    },
    [defaultLanguage?.value],
  );

  return {
    languageOptions,
    defaultLanguage,
    handleChange,
  };
};

export default useLanguage;
